export enum HttpMethod {
    POST = 'post',
    PUT = 'put',
    GET = 'get',
    DELETE = 'delete'
}
